import { UnreachableI18nCaseError } from './i18nUtils';
export function getKnowledgeBaseUrl(approvalType) {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return 'https://knowledge.hubspot.com/marketing-email/request-approval-to-send-a-marketing-email';
    case 'SOCIAL_BROADCAST':
      return 'https://knowledge.hubspot.com/social/request-approval-to-publish-a-social-media-post';
    case 'DEAL':
      return 'https://knowledge.hubspot.com/object-settings/pipeline-approvals';
    case 'QUOTE':
      return 'https://knowledge.hubspot.com/quotes/set-up-quote-approvals';
    /* Social content has same KB link */
    case 'BLOG_POST':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
    case 'KNOWLEDGE_ARTICLE':
      return 'https://knowledge.hubspot.com/website-and-landing-pages/approve-hubspot-content';
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
}